<template>
  <div class="mt-3">
    <b-card v-for="task in tasks" v-bind:key="task.id" class="mb-1">
      <template #header>
        <div class="d-flex justify-content-between">
          <div>
            <b-badge class="mr-1">#{{ task.id }}</b-badge>
            <b-badge :variant="task.status==='todo'?'primary':'success'" class="mr-1">
              {{ task.status === "todo" ? "К выполнению" : "Готово" }}
            </b-badge>
            <b-badge variant="danger" v-if="(Date.parse(task.due_date) < Date.now() && task.status==='todo')">
              Просрочено
            </b-badge>
          </div>
          <div>
            <b-link @click="openModalTask(task)" title="Открыть задачу">
              <b-icon-arrow-right-square-fill variant="primary"></b-icon-arrow-right-square-fill>
            </b-link>
          </div>
        </div>
      </template>
      <div class="task-created" title="Создано">
        <b-icon-calendar3-event class="mr-1"/>
        <span>{{ (new Date(Date.parse(task.created_at))).toLocaleString([], {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'}) }}</span>
      </div>
      <div class="task-due" title="Выполнить до">
        <b-icon-alarm class="mr-1"/>
        <span :class="(Date.parse(task.due_date) < Date.now() && task.status==='todo')?'text-danger':''">{{
            task.due_date ? (new Date(Date.parse(task.due_date))).toLocaleString([], {
              year: 'numeric',
              month: 'numeric',
              day: 'numeric', hour: 'numeric', minute: 'numeric'
            }) : ''
          }}</span></div>
      <div>{{ task.content }}</div>
      <div class="mt-2">
        <b-button v-if="task.status === 'todo'" @click="taskDone(task.id)" size="sm" variant="success">Завершить сейчас</b-button>
      </div>
    </b-card>
    <task-modal :form="taskForm" :isUpdate="true" @refresh="refreshList()"></task-modal>
  </div>
</template>

<script>
import TaskModal from "../components/TaskModal";

export default {
  name: "TaskList",
  props: ['tasks', 'deal'],
  components: { TaskModal },
  data() {
    return {
      taskForm: {},
      error: [],
      message: ''
    }
  },
  mounted() {
  },
  watch: {},
  methods: {
    refreshList() {
      this.$emit('refresh');
    },
    taskDone(id) {
      const promise = this.axios.post(process.env.VUE_APP_BACKEND_URL + '/api/tasks/' + id + '/done');

      return promise.then((response) => {
        if (response) {
          if (response.data.error === false) {
            this.error = false;
            this.$emit('refresh');
          } else {
            this.error = true;
            this.message = response.data.message;
          }
        }
      })
    },
    fetchTaskForm(id) {
      this.axios.get(process.env.VUE_APP_BACKEND_URL + '/api/tasks/' + id, {})
        .then((response) => {
          if (response) {
            if (response.data.error === false) {
              this.taskForm = response.data.task;
            } else {
              console.log(response.data.message);
            }
          }
        });
    },
    openModalTask(task) {
      this.taskForm = {}
      this.fetchTaskForm(task.id)
      this.$bvModal.show('task-modal')
    }
  }
}
</script>

<style>
.task-created, .task-due {
  font-size: 0.85rem;
}
</style>
